import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { Input } from 'components/Input/Input'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { TitleText } from 'styling/Typography'
import { IShiftProgramState } from 'types/operationShiftPrograms.interface'

export const Identity = ({ setStep, setState, state }: { setStep: (step: number) => void, setState?: any, state: IShiftProgramState }) => {

    const navigate = useNavigate()

    const handleNext = () => {
        if (!state.name) {
            toast.warn('Name is required')
            return
        }
        setStep(2)

    }
    const handleBack = () => navigate(-1)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setState((prev: IShiftProgramState) => ({ ...prev, [name]: value }))
    }

    return <>


        <Container>
            <ContainerHeader>
                <TitleText>Identity</TitleText>
            </ContainerHeader>
            <ContainerContent>
                <Flex column gap='1rem' >
                    <Input required invalid={!state.name} type='text' name='name' value={state.name} labelText='Name' onChange={handleChange} placeholder='Q1 Mill Throughput Push' />
                    <Input type='textarea' name='notes' value={state.notes} labelText='Notes' onChange={handleChange} placeholder='MTP-Q1-2026' />
                </Flex>

            </ContainerContent>

        </Container>
        <Flex gap='1rem' mt='32' justend>
            <Button variant='secondary' onClick={handleBack}>Back</Button>
            <Button variant='primary' onClick={handleNext} >Next</Button>
        </Flex>
    </>
}